export default __webpack_public_path__ + "static/media/guia-1.0f05fed4.png";